<template>
  <div class="footer">
    <!-- 装饰背景块 -->
    <div class="decor-blocks">
       <div class="block b1"></div>
       <div class="block b2"></div>
       <div class="block b3"></div>
       <div class="block b4"></div>
       <div class="block b5"></div>
       <div class="block b6"></div>
       <div class="block b7"></div>
     </div>
    <div class="footer-logo" >
      <img src="@/assets/DesignImage/logo2025.png" alt="">
      <p>Ecen的手办商城</p>
    </div>             
    <div class="footer-link">
      <a href="https://www.guat.edu.cn/" target="_blank">桂林航天工业学院</a><span>|</span>
      <a href="https://www.eduplus.net/" target="_blank">广东青软实训教育科技有限公司</a>
      
    </div>
    <div class="copyright">Copyright ©2025 <span class="domain">桂林航天工业学院</span> All Rights Reserved.</div>
  </div>
</template>
<script>
// 页脚导航组件：网站底部导航，包含logo、网站链接和版权信息
  export default{
    name:'nav-footer'
  }
</script>
<style lang="scss" scoped>
  .footer{
    padding: 40px 0;
    height: auto;
    border-top:4px solid #6c7bff;
    background: linear-gradient(135deg, #161a33 0%, #1f2442 45%, #2a3160 100%);
    color:#c9d0ff;
    font-size:16px;
    text-align:center;
    position: relative;
    overflow: hidden;
    .decor-blocks {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      .block {
        position: absolute;
        opacity: 0.1;
        background: repeating-linear-gradient(45deg, currentColor 0, currentColor 10px, transparent 10px, transparent 20px);
        &.b1 {
          left: -30px;
          top: -30px;
          width: 180px;
          height: 180px;
          color: #00d4ff;
          transform: rotate(-15deg);
        }
        &.b2 {
          right: -20px;
          bottom: -20px;
          width: 150px;
          height: 150px;
          color: #ff7bd5;
          opacity: 0.15;
          transform: rotate(15deg);
        }
        &.b3 {
          right: 10%;
          top: -40px;
          width: 120px;
          height: 120px;
          color: #6c7bff;
          opacity: 0.08;
          transform: rotate(30deg);
        }
        &.b4 {
          left: 25%;
          bottom: -50px;
          width: 200px;
          height: 100px;
          color: #ffb347;
          opacity: 0.05;
          transform: rotate(-10deg);
        }
        &.b5 {
          left: 45%;
          top: 20%;
          width: 80px;
          height: 80px;
          color: #00d4ff;
          opacity: 0.05;
          border-radius: 50%;
        }
        &.b6 {
          left: 55%;
          bottom: 10%;
          width: 120px;
          height: 120px;
          color: #ff7bd5;
          opacity: 0.07;
          transform: rotate(-25deg);
        }
        &.b7 {
          left: 35%;
          top: -20px;
          width: 100px;
          height: 100px;
          color: #6c7bff;
          opacity: 0.04;
          transform: rotate(45deg);
        }
      }
    }
    .footer-logo{
      margin-bottom:31px;
      display:flex;
      flex-direction:column;
      align-items:center;
      gap:8px;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      p{
        color:#e6e9ff;
        font-weight: bold;
        text-shadow: 0 2px 4px rgba(0,0,0,0.3);
      }
      img{
        width:230px;
        height:53px; 
        filter: drop-shadow(0 2px 8px rgba(255, 255, 255, 0.2));
      }
    }
    .footer-link{
      a{
        color:#c9d0ff;
        display:inline-block;
        &:hover{
          color:#ff7bd5;
        }
      }
      span{
        margin:0 10px;
        color:#8f99d6;
      }
      margin-bottom:13px;
    }
    .copyright{
      color:#a8b1e6;
      .domain{
        color:#6c7bff;
      }
    }
  }
</style>
